// extracted by mini-css-extract-plugin
module.exports = {"ctaWrapper":"jgp-fEWNE"};